export const SESSION_VISUALIZATION_CONSTANTS = {
  TITLE: "Resumen de la sesión",
  RESTART: "Reiniciar",
  STATE: "Estado",
  SESSION_QUALIFICATION: "Calificación de la sesión",
  SESSION_SUMARY: "Comentarios de la sesión",
  SESSION_DOCUMENTS: "Documentos de la sesión",
  SESSION_FORMS: "Formularios diligenciados",
  SESSION_INTERNAL_NUMBER: "Numero de Orden"
};
